//importação dos icones
import {
    faCogs,
    faChartLine,
    faHome,
    faStoreAlt,
    faGlobeAmericas,
    faFileInvoice,
    faMailBulk,
    faFileAlt,
    faNetworkWired,
    faBalanceScale,
    faBullhorn,
    faCalendar,
    faUsersCog,
    faUser,
    faBalanceScaleRight,
    faLock,
    faSearchLocation,
    faSearchDollar,
    faUserClock,
    faDollyFlatbed,
    faIdCard,
    faKey,
    faQrcode,
    faFileExport,
    faFileSignature,
    faCalendarAlt,
    faDigitalTachograph,
    faFile,
    faDonate,
    faPenSquare
} from "@fortawesome/free-solid-svg-icons";

//Views
import Login from "../views/Auth/Login";
import Dashboard from "../views/AreaRestrita/Dashboard";
import Regional from "../views/AreaRestrita/Cadastros/Regional";
import Secretaria from "../views/AreaRestrita/Cadastros/Secretaria";
import Formularios from "../views/AreaRestrita/Cadastros/Formularios";
import ModelosDeEmails from "../views/AreaRestrita/Cadastros/ModelosDeEmails";
import Documentos from "../views/AreaRestrita/Cadastros/Documentos";
import RegrasEVersoes from "../views/AreaRestrita/Cadastros/RegrasEVersoes";
import RegrasEVersoesSistema from "../views/AreaRestrita/RegrasEVersoesSistema";
import ConsultaRegrasVersoes from "../views/Shared/ConsultaRegrasVersoes";
import TipoDeFiscalizacao from "../views/AreaRestrita/Cadastros/TipoDeFiscalizacao";
import Infracoes from "../views/AreaRestrita/Cadastros/Infracoes";
import RoterioFiscalizacao from "../views/AreaRestrita/Cadastros/RoterioFiscalizacao";
import DiasNaoUteis from "../views/AreaRestrita/Cadastros/DiasNaoUteis";
import Usuarios from "../views/AreaRestrita/Seguranca/Usuarios";
import UnidadeMonetaria from "../views/AreaRestrita/Cadastros/UnidadeMonetaria";
import Perfil from "../views/AreaRestrita/Seguranca/Perfil";
import ConsultaFiscalizacao from "../views/AreaRestrita/ConsultaFiscalizacao";
import ConsultaInfracao from "../views/AreaRestrita/ConsultaInfracao";
import SolicitacaoFiscalizacao from "../views/AreaRestrita/SolicitacaoFiscalizacao";
import GerenciamentoDeArrecadacao from "../views/AreaRestrita/GerenciamentoDeArrecadacao";
import ConfirmacaoInfratores from "../views/AreaRestrita/ConfirmacaoInfratores";
import TrocaSenha from "../views/AreaRestrita/TrocaSenha";
import DownloadAplicativos from "../views/AreaRestrita/DownloadAplicativos";
import LayoutDiarioOficial from "../views/AreaRestrita/LayoutDiarioOficial";
import ExportacaoDiarioOficial from "../views/AreaRestrita/ExportacaoDiarioOficial";
import Contratadas from "../views/AreaRestrita/Cadastros/Contratadas";
import PlanoTrabalho from "../views/AreaRestrita/Cadastros/PlanoTrabalho";
import ColegiadoVotacao from "../views/AreaRestrita/Cadastros/ColegiadoVotacao";
import SolicitacaoFiscalizacaoStepper from "../views/AreaRestrita/SolicitacaoFiscalizacao/components/DemandasStepper";
import ExecucaoDeFiscalizacao from "../views/AreaRestrita/ExecucaoDeFiscalizacao";
import IndiceIPCA from "../views/AreaRestrita/Cadastros/IndiceIPCA";
import DividaAtiva from "../views/AreaRestrita/DividaAtiva";
import EmissaoBoletosEmLote from "../views/AreaRestrita/EmissaoBoletosEmLote";
import InfracoesList from "../views/AreaRestrita/InfracoesList";

//Shared
import FichaInfracao from "../views/Shared/FichaInfracao";
import FichaInfracaoHistorico from "../views/Shared/FichaInfracaoHistorico";
import AutoDeFiscalizacao from "../views/Shared/AutoDeFiscalizacao";
import ConsultaFichaFiscalizacaoViaLink from "../views/Shared/ConsultaFichaFiscalizacaoViaLink";
import ConsultaFichaInfracaoViaLink from "../views/Shared/ConsultaFichaInfracaoViaLink";

//Relatórios
import Relatorios from "../views/AreaRestrita/Relatorios/Relatorios";
import GerenciamentoArrecadacao from "../views/AreaRestrita/Relatorios/RelatorioGerenciamentoArrecadacao/GerenciamentoArrecadacao";
import DividaAtivaRelatorio from "../views/AreaRestrita/Relatorios/RelatorioDividaAtiva/DividaAtivaRelatorio";
import MapaTermicoFiscalizacoesRelatorio from "../views/AreaRestrita/Relatorios/RelatorioMapaTermicoFiscalizacoes/MapaTermicoFiscalizacoesRelatorio";
import RankingFiscalizacoesRelatorio from "../views/AreaRestrita/Relatorios/RelatorioRankingFiscalizacoes/RankingFiscalizacoesRelatorio";
import FichaInscricaoDividaAtiva from "../views/Shared/FichaInscricaoDividaAtiva";
import FichaSolicitacaoInscricaoDividaAtiva from "../views/Shared/FichaSolicitacaoInscricaoDividaAtiva";
import InfracoesRelatorio from "../views/AreaRestrita/Relatorios/RelatorioInfracoes/InfracoesRelatorio";
import ImpressaoFichaInfracaoCompleta from "../views/Shared/ImpressaoFichaInfracaoCompleta";
import ImpressaoFichaFiscalizacaoCompleta from "../views/Shared/ImpressaoFichaFiscalizacaoCompleta";
import FichaImpressaoSeparada from "../views/Shared/FichaImpressaoSeparada";
import FichaImpressaoCompleta from "../views/Shared/FichaImpressaoCompleta";

var routes = [
    {
        path: "/login",
        name: "ÁREA RESTRITA",
        icon: faChartLine,
        component: Login,
        layout: "/auth",
        sidebar: false
    },
    {
        path: "trocarsenha",
        name: "Trocar Senha",
        icon: faKey,
        component: TrocaSenha,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "consultaInfracaoMunicipe",
        name: "Consulta de Infração",
        icon: faDollyFlatbed,
        component: ConsultaFichaInfracaoViaLink,
        layout: "/auth",
        sidebar: false
    },
    {
        path: "consultaFiscalizacaoMunicipe",
        name: "Consulta de Fiscalização",
        icon: faDollyFlatbed,
        component: ConsultaFichaFiscalizacaoViaLink,
        layout: "/auth",
        sidebar: false
    },
    {
        path: "dashboard",
        name: "Dashboard",
        icon: faHome,
        component: Dashboard,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        path: "listaInfracoes",
        component: InfracoesList,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "ConsultaFiscalizacao",
        path: "consultaFiscalizacao",
        name: "Consulta Fiscalização",
        icon: faSearchLocation,
        component: ConsultaFiscalizacao,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "ConsultaFiscalizacao",
        path: "consultInfracao",
        name: "Consulta Infração",
        icon: faSearchDollar,
        component: ConsultaInfracao,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "ConsultaInfracao",
        path: "confirmacaoInfratores",
        name: "Confirmação de Infratores",
        icon: faIdCard,
        component: ConfirmacaoInfratores,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "Demandas",
        path: "demandas",
        name: "Demandas",
        icon: faUserClock,
        component: SolicitacaoFiscalizacao,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "ExecucaoFiscalizacao",
        path: "executar-fiscalizacao",
        name: "Executar Fiscalização",
        icon: faUserClock,
        component: ExecucaoDeFiscalizacao,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "Demandas",
        path: "demandas/ficha-demanda",
        name: "Demandas",
        icon: faUserClock,
        component: SolicitacaoFiscalizacaoStepper,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ficha-infracao-Municipe",
        component: FichaInfracao,
        layout: "/auth",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ficha-infracao",
        component: FichaInfracao,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ficha-infracao-historico",
        component: FichaInfracaoHistorico,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ficha-fiscalizacao",
        component: AutoDeFiscalizacao,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "GerenciamentoArrecadacao",
        path: "gerenciamentoDeArrecadacao",
        name: "Gerenciamento de Arrecadação",
        icon: faDollyFlatbed,
        component: GerenciamentoDeArrecadacao,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "dividaAtiva",
        path: "inscricaoDividaAtiva",
        name: "Dívida Ativa",
        icon: faPenSquare,
        component: DividaAtiva,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "emissaoBoletosEmLote",
        path: "emissaoBoletosEmLote",
        name: "Emissão de Boletos em Lote",
        icon: faMailBulk,
        component: EmissaoBoletosEmLote,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        path: "diarioOficial",
        name: "Layout diário oficial",
        icon: faFileAlt,
        component: LayoutDiarioOficial,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        path: "exportardiarioOficial",
        name: "Exportação diário oficial",
        icon: faFileExport,
        component: ExportacaoDiarioOficial,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    // Consulta pública, sem login: mesma listagem da rota /admin abaixo, servida pelos
    // endpoints [AllowAnonymous] da API. Fica fora do menu por não ter sidebar no layout
    // /empty — é acessada por link direto (CE-3522/CE-3738).
    {
        path: "regras-e-versoes-sistema",
        name: "Regras e Versões do Sistema",
        icon: faFileSignature,
        component: ConsultaRegrasVersoes,
        layout: "/empty",
        sidebar: false
    },
    // Consulta dentro do sistema, liberada a todos os usuários do sistema: sem
    // codigoFuncionalidade, portanto sem exigência de permissão de acesso (CE-3522).
    {
        path: "regras-e-versoes-sistema",
        name: "Regras e Versões do Sistema",
        icon: faFileSignature,
        component: RegrasEVersoesSistema,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        name: "Cadastros",
        icon: faCogs,
        layout: "/admin",
        sidebar: true,
        prefix: "cadastros",
        submenus: [
            {
                codigoFuncionalidade: "Cadastro.Documentos",
                descricao: "Documentos",
                path: "cadastros/documentos",
                name: "Documentos",
                icon: faFileAlt,
                layout: "/admin",
                component: Documentos,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.RegrasEVersoes",
                descricao: "Regras e Versões do Sistema",
                path: "cadastros/regras-e-versoes",
                name: "Regras e Versões do Sistema",
                icon: faFileSignature,
                layout: "/admin",
                component: RegrasEVersoes,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.ModeloEmail",
                descricao: "Modelos de e-mails",
                path: "cadastros/modelos-de-emails",
                name: "Modelos de e-mails",
                icon: faMailBulk,
                layout: "/admin",
                component: ModelosDeEmails,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.PlanoTrabalho",
                path: "planoTrabalho",
                name: "Plano trabalho",
                icon: faCalendarAlt,
                component: PlanoTrabalho,
                layout: "/admin",
                sidebar: true,
                modulo: ["secretaria"]
            },
            {
                codigoFuncionalidade: "Cadastro.ColegiadoVotacao",
                path: "colegiadoVotacao",
                name: "Colegiado de votação",
                icon: faDigitalTachograph,
                component: ColegiadoVotacao,
                layout: "/admin",
                sidebar: true,
                modulo: ["secretaria"]
            },
            {
                codigoFuncionalidade: "Cadastro.Contratada",
                path: "contratadas",
                name: "Contratadas",
                icon: faFileSignature,
                component: Contratadas,
                layout: "/admin",
                sidebar: true,
                modulo: ["secretaria"]
            },
            {
                codigoFuncionalidade: "Cadastro.Formulario",
                descricao: "Formulários",
                path: "cadastros/formularios",
                name: "Formulários",
                icon: faFileInvoice,
                layout: "/admin",
                component: Formularios,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.RoteiroFiscalizacao",
                descricao: " Fluxo Administrativo",
                path: "cadastros/RoteiroDeFiscalizacao",
                name: "Fluxo Administrativo",
                icon: faNetworkWired,
                layout: "/admin",
                component: RoterioFiscalizacao,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.TipoFiscalizacao",
                descricao: "Tipo De Fiscalizacao",
                path: "cadastros/TipoDeFiscalizacao",
                name: "Tipos de Fiscalização",
                icon: faBullhorn,
                layout: "/admin",
                component: TipoDeFiscalizacao,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.Infracoes",
                descricao: "Infrações",
                path: "cadastros/Infracoes",
                name: "Infrações",
                icon: faBalanceScale,
                layout: "/admin",
                component: Infracoes,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.DiaNaoUtil",
                descricao: "Dias não úteis",
                path: "cadastros/DiasNaoUteis",
                name: "Dias não úteis",
                icon: faCalendar,
                layout: "/admin",
                component: DiasNaoUteis,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.UnidadeMonetaria",
                descricao: "Unidade Monetária",
                path: "cadastros/unidadeMonetaria",
                name: "Unidade Monetária",
                icon: faBalanceScaleRight,
                layout: "/admin",
                component: UnidadeMonetaria,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Cadastro.IndiceIPCA",
                descricao: "Indíce IPCA",
                path: "cadastros/indiceIPCA",
                name: "Indíce IPCA",
                icon: faDonate,
                layout: "/admin",
                component: IndiceIPCA,
                sidebar: true
            },
        ],
        modulo: ["secretaria"]
    },
    {
        name: "Segurança",
        icon: faLock,
        layout: "/admin",
        sidebar: true,
        prefix: "seguranca",
        submenus: [
            {
                codigoFuncionalidade: "Seguranca.Perfis",
                descricao: "Perfil",
                path: "seguranca/Perfil",
                name: "Perfil",
                icon: faUsersCog,
                layout: "/admin",
                component: Perfil,
                sidebar: true
            },
            {
                codigoFuncionalidade: "Seguranca.Usuarios",
                descricao: "Usuarios",
                path: "cadastros/Usuarios",
                name: "Usuarios",
                icon: faUser,
                layout: "/admin",
                component: Usuarios,
                sidebar: true
            }
        ],
        modulo: ["secretaria"]
    },
    {
        path: "administrador/secretaria",
        name: "Secretaria",
        layout: "/admin",
        icon: faStoreAlt,
        component: Secretaria,
        sidebar: true,
        modulo: ["administrador"]
    },
    {
        path: "administrador/regionais",
        name: "Regionais",
        layout: "/admin",
        icon: faGlobeAmericas,
        component: Regional,
        sidebar: true,
        modulo: ["administrador"]
    },
    {
        path: "relatorios",
        name: "Relatórios",
        icon: faFileSignature,
        component: Relatorios,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        path: "downloadAplicativos",
        name: "Download do aplicativo",
        icon: faQrcode,
        component: DownloadAplicativos,
        layout: "/admin",
        sidebar: true,
        modulo: ["secretaria"]
    },
    {
        path: "ImpressaoInscricaoDividaAtiva",
        name: "Ficha de Inscrição em Dívida Ativaa",
        icon: faPenSquare,
        component: FichaInscricaoDividaAtiva,
        layout: "/empty",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ImpressaoFichaInfracaoCompleta",
        name: "Impressão Ficha Infração Completa",
        icon: faPenSquare,
        component: ImpressaoFichaInfracaoCompleta,
        layout: "/empty",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ImpressaoFichaFiscalizacaoCompleta",
        name: "Impressão Ficha Fiscalização Completa",
        icon: faPenSquare,
        component: ImpressaoFichaFiscalizacaoCompleta,
        layout: "/empty",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "FichaImpressaoSeparada",
        name: "Impressão Separada (CTR/Sistema de Cadastros/Documento)",
        icon: faPenSquare,
        component: FichaImpressaoSeparada,
        layout: "/empty",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "FichaImpressaoCompleta",
        name: "Impressão Completa da Infração",
        icon: faPenSquare,
        component: FichaImpressaoCompleta,
        layout: "/empty",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        path: "ImpressaoTermoSolicitacaoInscricaoDividaAtiva",
        name: "Termo de Solicitação de Inscrição em Dívida Ativa",
        icon: faPenSquare,
        component: FichaSolicitacaoInscricaoDividaAtiva,
        layout: "/empty",
        sidebar: false,
        modulo: ["secretaria"]
    },

    // rotas de relatórios
    {
        codigoFuncionalidade: "Relatorio.relatorioGerenciamentoArrecadacao",
        path: "relatorioGerenciamentoArrecadacao",
        name: "Gerenciamento de Arrecadação",
        icon: faFile,
        component: GerenciamentoArrecadacao,
        relatorio: true,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "Relatorio.relatorioDividaAtiva",
        path: "relatorioDividaAtiva",
        name: "Dívida Ativa e CADIN",
        icon: faFile,
        component: DividaAtivaRelatorio,
        relatorio: true,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "Relatorio.mapaTermicoFiscalizacoes",
        path: "mapaTermicoFiscalizacoes",
        name: "Mapa Térmico de Fiscalizações",
        icon: faFile,
        component: MapaTermicoFiscalizacoesRelatorio,
        relatorio: true,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "Relatorio.rankingFiscalizacoes",
        path: "rankingFiscalizacoes",
        name: "Ranking de Fiscalizações",
        icon: faFile,
        component: RankingFiscalizacoesRelatorio,
        relatorio: true,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
    {
        codigoFuncionalidade: "Relatorio.relatorioInfracoes",
        path: "relatorioInfracoes",
        name: "Relatório de Infrações",
        icon: faFile,
        component: InfracoesRelatorio,
        relatorio: true,
        layout: "/admin",
        sidebar: false,
        modulo: ["secretaria"]
    },
];

export default routes;